import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear error for this field when user types
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[+]?[\d\s()-]{7,15}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid phone number";
    }
    if (!formData.subject.trim()) newErrors.subject = "Subject is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSending(true);
      // Simulate sending (in production, connect to backend)
      setTimeout(() => {
        setIsSending(false);
        setSubmitted(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: ""
        });
        // Reset success message after 5 seconds
        setTimeout(() => setSubmitted(false), 5000);
      }, 1500);
    }
  };

  return (
    <div className="contact-wrapper py-5">
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h1 className="fw-bold contact-title">Contact Us</h1>
          <p className="text-muted fs-5">
            We'd love to hear from you. Get in touch with us.
          </p>
        </div>

        {/* CONTACT INFO CARDS */}
        <div className="row g-4 mb-5">

          {/* Phone */}
          <div className="col-md-4">
            <div className="contact-card p-4 text-center">
              <div className="contact-icon">
                <i className="bi bi-telephone-fill"></i>
              </div>
              <h5>Phone</h5>
              <p>
                <a href="tel:+919426159746">+91 94261 59746</a>
              </p>
              <p className="text-muted small">Mon-Sat, 9AM - 6PM</p>
            </div>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <div className="contact-card p-4 text-center">
              <div className="contact-icon">
                <i className="bi bi-envelope-fill"></i>
              </div>
              <h5>Email</h5>
              <p>
                <a href="mailto:misbahimission@gmail.com">
                  misbahimission@gmail.com
                </a>
              </p>
              <p className="text-muted small">We reply within 24 hours</p>
            </div>
          </div>

          {/* Address */}
          <div className="col-md-4">
            <div className="contact-card p-4 text-center">
              <div className="contact-icon">
                <i className="bi bi-geo-alt-fill"></i>
              </div>
              <h5>Address</h5>
              <p>
                79, Rehmat Nagar, Manubar Road,<br />
                Near Bypass Chowkadi, Bharuch<br />
                Gujarat, India - 392015
              </p>
            </div>
          </div>

        </div>

        {/* FORM & MAP ROW */}
        <div className="row g-4 mb-5">

          {/* Contact Form */}
          <div className="col-lg-7">
            <div className="contact-form-card p-5">

              {submitted ? (
                <div className="success-alert">
                  <i className="bi bi-check-circle-fill display-5 text-success mb-3 d-block"></i>
                  <h4>Message Sent Successfully! 🎉</h4>
                  <p>
                    Thank you for reaching out. We have received your message
                    and will get back to you as soon as possible. 
                    Jazakallahukhair!
                  </p>
                </div>
              ) : (
                <>
                  <h4 className="fw-bold mb-1">Send Us a Message</h4>
                  <p className="text-muted mb-4">
                    Fill out the form below and we'll get back to you.
                  </p>

                  <form onSubmit={handleSubmit} noValidate>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Full Name *</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          placeholder="Your full name"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">{errors.name}</div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Email Address *</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          placeholder="your.email@example.com"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Phone Number *</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          placeholder="+91 98765 43210"
                          className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                          onChange={handleChange}
                        />
                        {errors.phone && (
                          <div className="invalid-feedback">{errors.phone}</div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Subject *</label>
                        <input
                          type="text"
                          name="subject"
                          value={formData.subject}
                          placeholder="What is this regarding?"
                          className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                          onChange={handleChange}
                        />
                        {errors.subject && (
                          <div className="invalid-feedback">{errors.subject}</div>
                        )}
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-semibold">Message *</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        placeholder="Write your message here..."
                        className={`form-control ${errors.message ? "is-invalid" : ""}`}
                        rows="5"
                        onChange={handleChange}
                      />
                      {errors.message && (
                        <div className="invalid-feedback">{errors.message}</div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isSending}
                    >
                      {isSending ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Sending...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-send-fill me-2"></i>
                          Send Message
                        </>
                      )}
                    </button>
                  </form>
                </>
              )}

            </div>
          </div>

          {/* Map Placeholder */}
          <div className="col-lg-5">
            <div className="contact-card p-4 text-center h-100 d-flex flex-column align-items-center justify-content-center">
              <i className="bi bi-map-fill display-1" style={{ color: "#198754" }}></i>
              <h5 className="mt-3 fw-bold">Our Location</h5>
              <p className="text-muted mb-1">
                Jamia Mueeniyyah Azharul Uloom
              </p>
              <p className="text-muted mb-3">
                Welfare Hospital Chowkadi, Bharuch, Gujarat
              </p>
              <a
                href="https://maps.google.com/?q=Jamia+Mueeniyyah+Bharuch"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success rounded-pill px-4"
              >
                <i className="bi bi-box-arrow-up-right me-2"></i>
                View on Google Maps
              </a>
            </div>
          </div>

        </div>

        {/* SOCIAL MEDIA */}
        <div className="social-section p-5 text-center mb-5">
          <h4 className="fw-bold mb-3">Follow Us</h4>
          <p className="text-muted mb-4">
            Stay connected with us on social media for updates and Islamic knowledge.
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#1877F2" }}
            >
              <i className="bi bi-facebook"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#1DA1F2" }}
            >
              <i className="bi bi-twitter-x"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#E4405F" }}
            >
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#FF0000" }}
            >
              <i className="bi bi-youtube"></i>
            </a>
            <a
              href="https://wa.me/919426159746"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#25D366" }}
            >
              <i className="bi bi-whatsapp"></i>
            </a>
            <a
              href="https://telegram.org"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ backgroundColor: "#0088cc" }}
            >
              <i className="bi bi-telegram"></i>
            </a>
          </div>
        </div>

        {/* FOOTER */}
        <div className="text-center small text-muted">
          <p className="mb-0">© Misbahi Welfare Mission | Serving Humanity for the Sake of Allah</p>
        </div>

      </div>
    </div>
  );
};

export default Contact;

